import React, { useEffect, useState, useRef } from 'react';
import moment from 'moment';
import { Row, Col, Button, DatePicker, Select, Radio, Affix } from 'antd';
import { UserOutlined, HomeOutlined } from '@ant-design/icons';
import { useForm, Controller } from 'react-hook-form';
import YFinput from '../elements/YFInput';
import YFTextArea from '../elements/YFTextArea';
import { countries, getStateOfCountry } from '../../utils/countries';
import { createProfile } from '../../api';
import useApplicationSession from '../../session/UserSession';
import { useHistory, useLocation } from 'react-router-dom';
import { SUBSCRIPTION_EMPLOYEE } from '../../route/AppRouter';
import road from '../../assets/images/road.svg';
import car from '../../assets/images/car.svg';

const { Option } = Select;

const InformationForm = ({ value }) => {
    const token = useApplicationSession();
    const { control, register, handleSubmit, setValue, setError, errors, clearError } = useForm();

    const [stateOfCountry, setSateOfCountry] = useState([]);
    const inputRef = useRef();
    const history = useHistory();
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const onSubmit = (data) => {
        data.date_of_birth = data.date_of_birth?.format('DD-MM-YYYY');
        setLoading(true);
        createProfile({ token, request: data })
            .then((response) => {
                onNext();
            })
            .catch((error) => {
                if (error.errors) {
                    const nameArr = Object.keys(error.errors);
                    nameArr.forEach((key) => {
                        setError(key, 'notMatch', error.errors[key][0]);
                    });
                }
                setLoading(false);
            });
    };

    useEffect(() => {
        if (value !== null) {
            const values = [];
            const keys = Object.keys(value);
            keys.forEach((key) => {
                if (key === 'date_of_birth') {
                    values.push({
                        [key]: value[key] === '' ? '' : moment(value[key], 'DD-MM-YYYY'),
                    });
                } else {
                    values.push({ [key]: value[key] });
                }
            });
            setValue(values);
        } else {
            // for new user
        }
    }, [setValue, value]);

    const onNext = () => {
        history.push({
            pathname: `${SUBSCRIPTION_EMPLOYEE}`,
            search: location.search,
        });
    };

    return (
        <div className="formStatus">
            <form
                test_id="subscription-information-form"
                onSubmit={handleSubmit(onSubmit)}
                className="payment-information-form"
            >
                {/* -------- Personal information section -------- */}
                <div className="payment-information-label-container">
                    <UserOutlined className="personal-information-icon" style={{ fontSize: 20, padding: 10 }} />
                    <h4 className="payment-information-label">
                        Personal Information
                        <span className="personalEmailLabel">
                            <YFinput
                                disabled={false}
                                name="email"
                                register={register({
                                    required: true,
                                    pattern:
                                        /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                })}
                            />
                        </span>
                    </h4>
                </div>
                <Row className="horizontal-container">
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 12 }}
                        xl={{ span: 12 }}
                        xxl={{ span: 12 }}
                        className="horizontal-container-element"
                    >
                        <YFinput
                            test_id="subscription-information-first-name"
                            name="first_name"
                            type="text"
                            label="First Name"
                            placeholder="Enter First Name"
                            register={register({ required: { value: true, message: 'Please enter your first name.' } })}
                        />
                        <div className="form-error">
                            {errors.first_name?.type === 'notMatch' && (
                                <span className="formFieldError"> {errors.first_name?.message} </span>
                            )}
                        </div>
                    </Col>
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 12 }}
                        xl={{ span: 12 }}
                        xxl={{ span: 12 }}
                        className="horizontal-container-element"
                    >
                        <YFinput
                            test_id="subscription-information-last-name"
                            name="last_name"
                            type="text"
                            label="Last Name"
                            placeholder="Enter Last Name"
                            register={register({ required: { value: true, message: 'Please enter your last name.' } })}
                        />
                        <div className="form-error">
                            {errors.last_name?.type === 'notMatch' && (
                                <span className="formFieldError"> {errors.last_name?.message} </span>
                            )}
                        </div>
                    </Col>
                </Row>
                <Row className="horizontal-container">
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 12 }}
                        xl={{ span: 12 }}
                        xxl={{ span: 12 }}
                        className="horizontal-container-element"
                    >
                        <label>Date of Birth</label>
                        <Controller
                            as={
                                <DatePicker
                                    test_id="subscription-information-date-of-birth"
                                    name="date_of_birth"
                                    ref={inputRef}
                                    format={'DD-MM-YYYY'}
                                    inputReadOnly
                                />
                            }
                            control={control}
                            name="date_of_birth"
                            rules={{ required: true }}
                            onChange={([date]) => {
                                const duration = moment.duration(moment().diff(date));
                                const diff = duration.asYears();
                                if (diff < 18) {
                                    setError('date_of_birth', 'notMatch', 'Age must be greater than 18.');
                                    return;
                                } else {
                                    clearError('date_of_birth');
                                }
                                return date;
                            }}
                        />
                        <div className="form-error">
                            {errors.date_of_birth?.type === 'required' && (
                                <span className="formFieldError">
                                    {' '}
                                    Please choose your date of birth. (Eg: 01-01-2002){' '}
                                </span>
                            )}
                            {errors.date_of_birth?.type === 'notMatch' && (
                                <span className="formFieldError"> {errors.date_of_birth?.message} </span>
                            )}
                        </div>
                    </Col>
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 12 }}
                        xl={{ span: 12 }}
                        xxl={{ span: 12 }}
                        className="horizontal-container-element"
                    >
                        <YFinput
                            test_id="subscription-information-office-email"
                            name="office_email"
                            type="text"
                            label="Work Email"
                            placeholder="Enter Work Email"
                            register={register({
                                required: true,
                                pattern:
                                    /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                            })}
                        />
                        <div className="form-error">
                            {errors.office_email?.type === 'required' && (
                                <span className="formFieldError">Please enter your work email.</span>
                            )}
                            {errors.office_email?.type === 'pattern' && (
                                <span className="formFieldError">Please enter valid email format.</span>
                            )}
                            {errors.office_email?.type === 'notMatch' && (
                                <span className="formFieldError"> {errors.office_email?.message} </span>
                            )}
                        </div>
                    </Col>
                </Row>
                <Row className="horizontal-container">
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 12 }}
                        xl={{ span: 12 }}
                        xxl={{ span: 12 }}
                        className="horizontal-container-element"
                    >
                        <YFinput
                            test_id="subscription-information-contact-number"
                            name="contact_number"
                            type="number"
                            min="0"
                            step="0"
                            label="Personal Phone"
                            placeholder="Enter Phone (Personal)"
                            register={register({
                                required: true,
                                minLength: {
                                    value: 6,
                                    message: 'Phone number must be minimum 6 digits. ',
                                },
                                maxLength: {
                                    value: 13,
                                    message: 'Phone number must be maximum 13 digits',
                                },
                            })}
                        />
                        <div className="form-error">
                            {errors.contact_number?.type === 'required' && (
                                <span className="formFieldError">Please enter your contact number.</span>
                            )}
                            {errors.contact_number?.type === 'minLength' && (
                                <span className="formFieldError">{errors.contact_number?.message}</span>
                            )}
                            {errors.contact_number?.type === 'maxLength' && (
                                <span className="formFieldError">{errors.contact_number?.message}</span>
                            )}
                            {errors.contact_number?.type === 'notMatch' && (
                                <span className="formFieldError"> {errors.contact_number?.message} </span>
                            )}
                        </div>
                    </Col>
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 12 }}
                        xl={{ span: 12 }}
                        xxl={{ span: 12 }}
                        className="horizontal-container-element"
                    >
                        <YFinput
                            test_id="subscription-information-office-contact-number"
                            name="office_contact_number"
                            type="number"
                            min="0"
                            step="0"
                            label="Work Phone"
                            placeholder="Enter Work Phone"
                            register={register({
                                required: true,
                                minLength: {
                                    value: 6,
                                    message: 'Phone number must be minimum 6 digits. ',
                                },
                                maxLength: {
                                    value: 13,
                                    message: 'Phone number must be maximum 13 digits. ',
                                },
                            })}
                        />
                        <div className="form-error">
                            {errors.office_contact_number?.type === 'required' && (
                                <span className="formFieldError">Please enter your work contact number.</span>
                            )}
                            {errors.office_contact_number?.type === 'minLength' && (
                                <span className="formFieldError">{errors.office_contact_number?.message}</span>
                            )}
                            {errors.office_contact_number?.type === 'maxLength' && (
                                <span className="formFieldError">{errors.office_contact_number?.message}</span>
                            )}
                            {errors.office_contact_number?.type === 'notMatch' && (
                                <span className="formFieldError"> {errors.office_contact_number?.message} </span>
                            )}
                        </div>
                    </Col>
                </Row>
                <Row className="horizontal-container">
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 12 }}
                        xl={{ span: 12 }}
                        xxl={{ span: 12 }}
                        className="horizontal-container-element"
                    >
                        <label htmlFor="martial_status">Martial status</label>
                        <Controller
                            name="martial_status"
                            as={
                                <Select
                                    id="subscription-information-martial-status"
                                    showSearch
                                    className="yf-select"
                                    style={{ width: '100%' }}
                                    placeholder="Select Matrial Status"
                                    ref={inputRef}
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {martialStatus.map((item) => {
                                        return (
                                            <Option value={item.value} key={item.id}>
                                                {item.label}
                                            </Option>
                                        );
                                    })}
                                </Select>
                            }
                            onChange={([selected]) => {
                                return selected;
                            }}
                            rules={{ required: true }}
                            control={control}
                        />
                        {errors.martial_status?.type === 'required' && (
                            <span className="formFieldError">Please select martial status.</span>
                        )}
                        {errors.martial_status?.type === 'notMatch' && (
                            <span className="formFieldError"> {errors.martial_status?.message} </span>
                        )}
                    </Col>
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 12 }}
                        xl={{ span: 12 }}
                        xxl={{ span: 12 }}
                        className="horizontal-container-element"
                    >
                        <YFinput
                            test_id="subscription-information-no-of-dependent"
                            name="no_of_dependent"
                            type="number"
                            min="0"
                            step="0"
                            label="Number of Dependents"
                            placeholder="Enter Nunber of Dependents"
                            register={register({
                                required: true,
                                minLength: {
                                    value: 1,
                                    message: 'Number of dependents must be 1 digit',
                                },
                                maxLength: {
                                    value: 100,
                                    message: 'Number of dependents must be 3 digit',
                                },
                            })}
                        />
                        <div className="form-error">
                            {errors.no_of_dependent?.type === 'required' && (
                                <span className="formFieldError">Please enter your dependents family members.</span>
                            )}
                            {errors.no_of_dependent?.type === 'minLength' && (
                                <span className="formFieldError">{errors.contact_number?.message}</span>
                            )}
                            {errors.no_of_dependent?.type === 'notMatch' && (
                                <span className="formFieldError"> {errors.no_of_dependent?.message} </span>
                            )}
                        </div>
                    </Col>
                </Row>
                {/* -------- personal information section end -------- */}
                {/* -------- Address information section -------- */}
                <div className="payment-information-label-container">
                    <HomeOutlined className="personal-information-icon" style={{ fontSize: 20, padding: 10 }} />
                    <h4 className="payment-information-label">Address Information</h4>
                </div>
                <Row className="horizontal-container">
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 24 }}
                        lg={{ span: 24 }}
                        xl={{ span: 24 }}
                        xxl={{ span: 24 }}
                        className="horizontal-container"
                    >
                        <YFTextArea
                            test_id="subscription-information-address"
                            name="address"
                            type="text"
                            label="Address"
                            placeholder="Enter Address"
                            rows={8}
                            register={register({ required: { value: true, message: 'Please enter your address.' } })}
                        />
                        {errors.address?.type === 'required' && (
                            <span className="formFieldError"> {errors.address?.message} </span>
                        )}
                    </Col>
                </Row>
                <Row className="horizontal-container">
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 24 }}
                        lg={{ span: 24 }}
                        xl={{ span: 24 }}
                        xxl={{ span: 24 }}
                        className="horizontal-container"
                    >
                        <Controller
                            name="property"
                            as={
                                <Radio.Group>
                                    <Radio value="OWN_HOME_OUTRIGHT">Own Home Outright</Radio>
                                    <Radio id="subscription-information-property" value="RENTING">
                                        Renting
                                    </Radio>
                                    <Radio value="LIVING_WITH_FAMILY">Living with family</Radio>
                                </Radio.Group>
                            }
                            control={control}
                            onChange={([event]) => {
                                return event.target.value;
                            }}
                            rules={{ required: true }}
                        />
                        {errors?.property?.type === 'required' && (
                            <span className="formFieldError">Please select your property type.</span>
                        )}
                        {errors.property?.type === 'notMatch' && (
                            <span className="formFieldError"> {errors.property?.message} </span>
                        )}
                    </Col>
                </Row>
                <Row className="horizontal-container">
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 24 }}
                        lg={{ span: 24 }}
                        xl={{ span: 24 }}
                        xxl={{ span: 24 }}
                        className="horizontal-container"
                    >
                        <YFinput
                            test_id="subscription-information-time-at-address"
                            name="time_at_address"
                            type="text"
                            label="Duration"
                            placeholder="Enter duration at current address"
                            register={register({ required: { value: false } })}
                        />
                    </Col>
                </Row>
                <Row className="horizontal-container">
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 12 }}
                        xl={{ span: 12 }}
                        xxl={{ span: 12 }}
                        className="horizontal-container-element"
                    >
                        <label htmlFor="country">Country</label>
                        <Controller
                            name="country"
                            as={
                                <Select
                                    showSearch
                                    id="subscription-information-country"
                                    className="yf-select"
                                    style={{ width: '100%' }}
                                    placeholder="Select Country"
                                    ref={inputRef}
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {countries.map((item) => {
                                        return (
                                            <Option test_id={item.value} value={item.value} key={item.id}>
                                                {item.label}
                                            </Option>
                                        );
                                    })}
                                </Select>
                            }
                            onChange={([selected]) => {
                                setSateOfCountry(getStateOfCountry(selected));
                                setValue('state', undefined);
                                return selected;
                            }}
                            rules={{ required: { value: true, message: 'Please enter country' } }}
                            control={control}
                        />
                        <div className="form-error">
                            {errors.country?.type === 'required' && (
                                <span className="formFieldError"> Please select your country. </span>
                            )}
                            {errors.country?.type === 'notMatch' && (
                                <span className="formFieldError"> {errors.country?.message} </span>
                            )}
                        </div>
                    </Col>
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 12 }}
                        xl={{ span: 12 }}
                        xxl={{ span: 12 }}
                        className="horizontal-container-element"
                    >
                        <label htmlFor="state">State</label>
                        <Controller
                            name="state"
                            as={
                                <Select
                                    id="subscription-information-state"
                                    showSearch
                                    className="yf-select"
                                    style={{ width: '100%' }}
                                    placeholder="Select State"
                                    ref={inputRef}
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {stateOfCountry.map((item) => {
                                        return (
                                            <Option value={item.value} key={item.id}>
                                                {item.label}
                                            </Option>
                                        );
                                    })}
                                </Select>
                            }
                            onChange={([selected]) => {
                                return selected;
                            }}
                            rules={{ required: true }}
                            control={control}
                        />
                        <div className="form-error">
                            {errors.state?.type === 'required' && (
                                <span className="formFieldError"> Please select your state. </span>
                            )}
                            {errors.state?.type === 'notMatch' && (
                                <span className="formFieldError"> {errors.state?.message} </span>
                            )}
                        </div>
                    </Col>
                </Row>
                <Row className="horizontal-container">
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 12 }}
                        xl={{ span: 12 }}
                        xxl={{ span: 12 }}
                        className="horizontal-container-element"
                    >
                        <YFinput
                            test_id="subscription-information-city"
                            name="city"
                            type="text"
                            label="City"
                            placeholder="Enter City"
                            register={register({ required: { value: true, message: 'Please enter your city' } })}
                        />
                        <div className="form-error">
                            {errors.city?.type === 'notMatch' && (
                                <span className="formFieldError"> {errors.city?.message} </span>
                            )}
                        </div>
                    </Col>
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 12 }}
                        xl={{ span: 12 }}
                        xxl={{ span: 12 }}
                        className="horizontal-container-element"
                    >
                        <YFinput
                            test_id="subscription-information-post-code"
                            name="post_code"
                            type="number"
                            min="0"
                            step="0"
                            label="Postal Code"
                            placeholder="Enter Postal Code"
                            register={register({
                                required: true,
                                // minLength: {
                                //   value: 4,
                                //   message: "Postal Code must be minimum 4 digits.",
                                // },
                                maxLength: {
                                    value: 10,
                                    message: 'Postal Code must be minimum 10 digits.',
                                },
                            })}
                        />
                        <div className="form-error">
                            {errors.post_code?.type === 'required' && (
                                <span className="formFieldError"> Please enter your postal code. </span>
                            )}
                            {errors.post_code?.type === 'minLength' && (
                                <span className="formFieldError">{errors.post_code.message}</span>
                            )}
                            {errors.post_code?.type === 'maxLength' && (
                                <span className="formFieldError">{errors.post_code.message}</span>
                            )}
                            {errors.post_code?.type === 'notMatch' && (
                                <span className="formFieldError"> {errors.post_code?.message} </span>
                            )}
                        </div>
                    </Col>
                </Row>
                <Row className="horizontal-container">
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 24 }}
                        lg={{ span: 24 }}
                        xl={{ span: 24 }}
                        xxl={{ span: 24 }}
                        className="horizontal-container"
                    >
                        <YFTextArea
                            test_id="subscription-information-address-line-two"
                            name="address_line_two"
                            type="text"
                            label="Previous Address (If less than 2 years)"
                            placeholder="Enter Previous Address"
                            rows={8}
                            register={register({ required: false })}
                        />
                    </Col>
                </Row>
                {/* -------- Address information section end-------- */}
                {/* -------- Button section -------- */}
                <br />
                <div className="subscriptionContentContainerSteps">
                    <Button
                        test_id="subscription-information-submit"
                        loading={loading}
                        className="secondary-btn profileNext"
                        htmlType="submit"
                    >
                        NEXT
                    </Button>
                </div>
                {/* --------  Button section end  -------- */}
            </form>

            <Affix offsetBottom={0}>
                <div className="formStepper">
                    <img src={car} alt="Car" className="formStepperCar step1" />
                    <img src={road} alt="Road" className="formStepperRoad" />
                </div>
            </Affix>
        </div>
    );
};

const martialStatus = [
    {
        label: 'Single',
        value: 'Single',
    },
    {
        label: 'Married',
        value: 'Married',
    },
];

export default InformationForm;
